import { createRegionsClient } from '@pay-roadrunner/regions-ui';
import { authFetch } from '../../auth/authFetch';
import { getApiBaseUrl } from '../../auth/api';

// Region fetching logic itself lives in the shared @pay-roadrunner/regions-ui
// package (coded once, reused by ui/ and admin-ui/); this file just wires in
// this app's own auth/base-URL adapter.
export const { fetchRegions } = createRegionsClient({ getBaseUrl: getApiBaseUrl, fetchImpl: authFetch });
